// extracted by mini-css-extract-plugin
module.exports = {"typing":"_15HDL","background":"_34wgC","content":"SaEYS","wrapper":"_1DXec","member":"oUyxu","separator":"_3kHNp"};